import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class UserService {

	getItems(keyword,start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/user_list';
		const formData = new FormData();
		formData.append('start', start);
		formData.append('keyword', keyword);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	saveItem(postObj,name,email,password) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/save_user';
		const formData = new FormData();
		formData.append('branch_id', postObj.branchId);
		formData.append('pharmacy_id', postObj.pharmacyId);
		formData.append('role', postObj.role);
		formData.append('address', postObj.address);
		formData.append('contact', postObj.contact);
		formData.append('image', postObj.image);
		formData.append('description',postObj.description);
		formData.append('name', name);
		formData.append('email', email);
		formData.append('password',password);
		formData.append('status',postObj.status);
		
		// For Pharmacy Admin, send pharmacy_ids array
		if (postObj.pharmacyIds && postObj.pharmacyIds.length > 0) {
			postObj.pharmacyIds.forEach((id, index) => {
				formData.append(`pharmacy_ids[${index}]`, id);
			});
		}
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => {

			ExceptionHandling.HandleErrors(e);
		})
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	updateItem(postObj,name,email) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/edit_users';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('branch_id', postObj.branchId);
		formData.append('pharmacy_id', postObj.pharmacyId);
		formData.append('role', postObj.role);
		formData.append('address', postObj.address);
		formData.append('contact', postObj.contact);
		formData.append('description',postObj.description);
		formData.append('name', name);
		formData.append('email', email);
		
		// For Pharmacy Admin, send pharmacy_ids array
		if (postObj.pharmacyIds && postObj.pharmacyIds.length > 0) {
			postObj.pharmacyIds.forEach((id, index) => {
				formData.append(`pharmacy_ids[${index}]`, id);
			});
		}

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	getItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_user/' + data.id;
		return instance().get(api)
			.then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	changeStatus(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_user';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('status', postObj.status);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	changePin(postObj,password) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/change_pin';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('password', password);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	uploadProfileImage(image,postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/upload_user_image';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('image', image);
		formData.append('previousImage', postObj.image);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	searchUser(keyword) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_users';
		const formData = new FormData();
		formData.append('keyword', keyword);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

}